import AttachmentsList from './AttachmentsList';

export default AttachmentsList;